import { useMemo } from "react";
import type { SurfaceWithIlluminance } from "../types";

export type HeatmapPoint = { x: number; y: number; value: string };

type UseLuminanceDataParams = {
  luminance: { values: number[]; [key: string]: unknown };
  illuminance: { "pts.x": unknown; "pts.y": unknown; "dim.x": unknown; "dim.y": unknown };
  surfaces: SurfaceWithIlluminance[];
  sidewalk_placing: string | null;
};

export function useLuminanceData({ luminance, illuminance, surfaces, sidewalk_placing }: UseLuminanceDataParams) {
  return useMemo(() => {
    const ptsX = Number.parseInt(String(illuminance["pts.x"]));
    const ptsY = Number.parseInt(String(illuminance["pts.y"]));
    const dimX = Number.parseFloat(String(illuminance["dim.x"]));
    const dimY = Number.parseFloat(String(illuminance["dim.y"]));

    const luminanceValues = luminance.values;
    const maxLuminanceValue = luminanceValues?.length > 0 ? Math.max(...luminanceValues) : 0;

    const luminanceData: HeatmapPoint[] = [];
    for (let i = ptsY - 1; i >= 0; i--) {
      for (let j = 0; j < ptsX; j++) {
        luminanceData.push({ x: j, y: i, value: luminanceValues[i * ptsX + j].toFixed(1) });
      }
    }

    return { ptsX, ptsY, dimX, dimY, luminanceData, maxLuminanceValue };
  }, [luminance, illuminance, surfaces, sidewalk_placing]);
}
